// extracted by mini-css-extract-plugin
export default {"hero-container":"Hero_hero-container__6QVof","hero":"Hero_hero__r7RcG","hero-text-container":"Hero_hero-text-container__L4Vv2"};